import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "select-bar-wrapper" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "panel_left" }
const _hoisted_5 = { class: "upload-wrapper" }
const _hoisted_6 = { class: "image-slot" }
const _hoisted_7 = {
  key: 1,
  class: "uploader-placeholder"
}
const _hoisted_8 = { class: "action-bar" }
const _hoisted_9 = { class: "panel_right" }
const _hoisted_10 = { class: "phone-mockup" }
const _hoisted_11 = { class: "phone-screen" }
const _hoisted_12 = { class: "phone-media" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "video-container"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "media-placeholder"
}
const _hoisted_17 = {
  key: 2,
  class: "media-placeholder"
}
const _hoisted_18 = { class: "phone-content" }
const _hoisted_19 = { class: "app-content-title" }
const _hoisted_20 = { class: "app-content-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group_button = _resolveComponent("el-radio-group-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_VideoPlay = _resolveComponent("VideoPlay")!
  const _component_Picture = _resolveComponent("Picture")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_segmented, {
        modelValue: _ctx.levelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.levelValue) = $event)),
        options: _ctx.levelsOptions,
        block: "",
        onChange: _ctx.changeOption,
        size: "large",
        class: "selectBar"
      }, null, 8, ["modelValue", "options", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            "label-width": "auto",
            "label-position": "top",
            ref: "ruleForm",
            "status-icon": "",
            class: "clean-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "复盘标题" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.reviewTitle,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.reviewTitle) = $event)),
                    placeholder: "请输入复盘标题...",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "复盘内容" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.reviewContent,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.reviewContent) = $event)),
                    type: "textarea",
                    placeholder: "请输入复盘的核心内容...",
                    size: "large",
                    rows: "8",
                    maxlength: "500",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "展示媒体类型" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.mediaType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mediaType) = $event)),
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group_button, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: "image" }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("图片", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, { label: "video" }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("视频链接", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.mediaType === 'image')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "复盘图片"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_upload, {
                          class: "avatar-uploader",
                          action: _ctx.UpdateApi,
                          "show-file-list": false,
                          "on-success": _ctx.handleAvatarSuccess,
                          "before-upload": _ctx.beforeAvatarUpload,
                          "file-list": _ctx.fileList,
                          disabled: _ctx.allowUpload
                        }, {
                          default: _withCtx(() => [
                            (_ctx.form.reviewImg)
                              ? (_openBlock(), _createBlock(_component_el_image, {
                                  key: 0,
                                  src: _ctx.form.reviewImg,
                                  class: "avatar",
                                  alt: "复盘图片",
                                  fit: "cover"
                                }, {
                                  error: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_icon_picture)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["src"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  }),
                                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "upload-text" }, "选择上传图片", -1))
                                ]))
                          ]),
                          _: 1
                        }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"]),
                        (_ctx.allowUpload)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "warning",
                              plain: "",
                              class: "clear-img-btn",
                              onClick: _ctx.clearImage
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.mediaType === 'video')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "视频链接"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.reviewLink,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.reviewLink) = $event)),
                        placeholder: "请输入视频的嵌入式 URL (例如: https://www.youtube.com/embed/...)",
                        type: "url",
                        size: "large",
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-top":"6px","line-height":"1.4"} }, " * 提示：为了能在网页上正常播放，请确保使用的是支持嵌入的链接格式（如带有 /embed/ 的链接）。 ", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "save-btn",
              size: "large",
              onClick: _ctx.saveSettings
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" 保存当前关卡 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "preview-title" }, "App 实时预览", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.mediaType === 'image' && _ctx.form.reviewImg)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.form.reviewImg,
                      alt: "图片预览",
                      class: "preview-img"
                    }, null, 8, _hoisted_13))
                  : (_ctx.mediaType === 'video')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_ctx.form.reviewLink)
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 0,
                              src: _ctx.form.reviewLink,
                              scrolling: "no",
                              border: "0",
                              frameborder: "no",
                              framespacing: "0",
                              allowfullscreen: "true",
                              class: "preview-iframe"
                            }, null, 8, _hoisted_15))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_component_el_icon, { style: {"font-size":"32px"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_VideoPlay)
                                ]),
                                _: 1
                              }),
                              _cache[10] || (_cache[10] = _createElementVNode("span", { style: {"margin-top":"8px","font-size":"12px"} }, "暂无视频链接", -1))
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_el_icon, { style: {"font-size":"32px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Picture)
                          ]),
                          _: 1
                        }),
                        _cache[11] || (_cache[11] = _createElementVNode("span", { style: {"margin-top":"8px","font-size":"12px"} }, "暂无图片展示", -1))
                      ]))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.form.reviewTitle || "暂无标题"), 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.form.reviewContent || "暂无内容描述..."), 1)
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "phone-bottom-action" }, [
                _createElementVNode("div", { class: "continue-button" }, "继续")
              ], -1))
            ])
          ])
        ])
      ])
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "zhanwei4" }, null, -1))
  ], 64))
}